import React from 'react';
import { Headline } from '../components/headline/Headline';
import Workcards from '../components/workcards/Workcards';

import imgSvt from '../assets/img/img-work-svt.png';
import imgSpectaris from '../assets/img/img-work-spectaris.png';
import imgFerienhaus from '../assets/img/img-work-ferienhaus.png';
import imgGetwet from '../assets/img/img-work-getwet.png';
import imgMarbin from '../assets/img/img-work-marbin.png';

function Work() {
  return (
    <main>
      <div className="border-bottom">
        <Headline level="h2">SELECTED WORK</Headline>
      </div>
      <div className="scrollable cardgrid">
        <Workcards headline='svt' subline='Design, Dev & PM' link='svt' image={ imgSvt } text='Lead im gesamten Online-Bereich der Unternehmens&shy;gruppe' year='2023'/>
        <Workcards headline='Spectaris' subline='Design & Dev' link='spectaris' image={ imgSpectaris } text='Komplettes Design fürs Trendforum & Dev auf WordPress-Basis' year='2023'/>
        <Workcards headline='Ferienhaus & Co.' subline='Design, Dev & PM' link='ferienhaus' image={ imgFerienhaus } text='Entwicklung des UI, Kundenbetreuung und Dev mit API Anbindung' year='2022'/>
        <Workcards headline='GetWet' subline='Design & Dev' link='getwet' image={ imgGetwet } text='Electron Desktop App zur Erinnnerung deine Pflanzen zu gießen' year='2022'/>
        <Workcards headline='marb.in' subline='Design & Dev' link='marbin' image={ imgMarbin } text='Meine Street&shy;photography Gallerie mit Anbindung an Cloudinary' year='2023'/>
      </div>
    </main>
  );
}

export default Work;